import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../../../Config/flagstoneTheme';
import clsx from 'clsx';
import {machineScissorZone} from '../../../../Config/constants'

export default function SelectZoneContainer(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    
    return <div className={classes.zoneContainer}>
        <div className={classes.title}>{t("Set zone for current order")}</div>
        <div className={classes.zones}>
            {props.zonesWithScissors.map(x => {
                let index = props.zonesWithScissors.indexOf(props.zonesWithScissors.find(y => y.zone === x.zone))
                let firstZone = index === 0
                let lastZone = index === props.zonesWithScissors.length - 1
                return (<button onClick={() => props.setZones(x)} className={clsx({ [classes.zoneSelected]: props.selectedZones.some(y => y.zone === x.zone), [classes.zoneNotSelected]: !props.selectedZones.some(y => y.zone === x.zone)})} disabled={x.used} style={{ borderRadius: firstZone ? "7px 0 0 7px" : lastZone ? "0 7px 7px 0" : "none", borderLeft: firstZone ? "1px solid #00000029" : "none" ,backgroundColor:x.used && "#00000029"}}>
                    {x.zone}
                </button>)
            }
            )}

        </div>
    </div>
}

const useStyles = makeStyles({

    zoneSelected: {
        height: "50px",
        width: "55px",
        color: FlagstoneTheme.palette.primary.main,
        backgroundColor: "#E6E8FE",
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        float: "left",
        outline: "none",
        border: "1px solid #00000029",
        borderLeft: "none",
        cursor: "pointer",
    },
    zoneNotSelected: {
        height: "50px",
        width: "55px",
        color: "#020100",
        backgroundColor: "white",
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        float: "left",
        outline: "none",
        cursor: "pointer",
        border: "1px solid #00000029",
        borderLeft: "none"
    },
    zoneContainer: {
        margin: "10px",
        height:"90px"
    },
    zones: {
        marginTop: "10px"
    },
    title: {
        color: "#020100",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
    }
});